const es = {
  "sale.sale.dispatch_today": "¿Quién va a despachar hoy?",
  "sale.sale.dispatch_today_text":
    "  Paso 1: Selecciona un domiciliario para comenzar a gestionar sus pedidos.",
  "sale.sale.delivery.panel_text":
    "Administra el flujo completo de domicilios: despacha, factura, imprime y liquida.",
  "sale.sale.delivery": "Domiciliario",
  "sale.sale.delivery_change": "Cambiar Domiciliario",
  "sale.sale.delivery.panel_requirements":
    "Por favor revise los requisitos para continuar.",
  "sale.sale.delivery_ok": "Entendido",
  "sale.sale.delivery.panel_instructions":
    "Factura e imprime cada pedido. Luego selecciónalos y confirma el despacho.",
  "sale.sale.delivery.panel_liquidate_instructions":
    "Selecciona las facturas entregadas y pagadas para liquidarlas.",
  "sale.sale.delivery.panel_orders_ready": "Pedidos Listos Para Salida :",
  "sale.sale.delivery.panel_pending_documents":
    "Documentos Pendientes de Pago :",
  "sale.sale.delivery.panel.column.number": "Número",
  "sale.sale.delivery.panel.column.client": "Cliente",
  "sale.sale.delivery.panel.column.total": "Total",
  "sale.sale.delivery.panel.column.payment": "Pago",
  "sale.sale.delivery.panel.column.shipment_date": "F. Entrega",
  "sale.sale.delivery.panel.column.delivery_time": "Hora Entrega",
  "sale.sale.delivery.panel.column.state": "Estado",
  "sale.sale.delivery.panel.column.order_status": "Orden",
  "sale.sale.delivery.panel.column.actions": "Acciones",
  "sale.sale.delivery.panel.action.bill": "Facturar",
  "sale.sale.delivery.panel.action.print": "Imprimir",
  "sale.sale.delivery.panel.no_address": "Sin dirección",
  "sale.sale.delivery.panel.status.commanded": "Comandado",
  "sale.sale.delivery.panel.status.dispatched": "Despachado",
  "sale.sale.delivery.panel.status.draft": "Borrador",
  "delivery.panel.delivery": "Domiciliario",
  "sale.sale.delivery.panel_progress": "Progreso",
  "sale.sale.delivery.panel.modal.title": "Confirmar Recepción de Dinero",
  "sale.sale.delivery.panel.modal.subtitle":
    "Registre el pago de las facturas seleccionadas",
  "sale.sale.delivery.panel.modal.total_label": "Monto Total a Recibir",
  "sale.sale.delivery.panel.modal.selected_invoices":
    "{count} Facturas seleccionadas",
  "sale.sale.delivery.panel.modal.select_payment": "Seleccione Medio de Pago",
  "sale.sale.delivery.panel.modal.confirm_button": "Confirmar y Procesar",
  "sale.sale.delivery.panel.modal.processing_title": "Procesando facturas...",
  "sale.sale.delivery.panel.modal.processing_message":
    "Por favor no cierre la ventana",
  "sale.sale.delivery.panel.modal.completed_message":
    "El dinero ha sido registrado correctamente.",
  "sale.sale.delivery.panel_ok": "Ok",
  "sale.sale.delivery.panel.selected": "Seleccionados",
  "sale.sale.delivery.panel.total": "Total",
  "delivery.panel.by_dispached": "1. Despachar",
  "delivery.panel.dispached_liquidate": "2. Liquidación",
  "sale.sale.delivery.panel.column.delivery_amount": "Valor Domicilio",
  "delivery.panel.reports": "Reportes",
  "sale_pos_frontend.detailed_deliveryman_report": "Reporte Domiciliario",
  "sale_pos_frontend.detailed_deliveryman.start.shop": "Tienda",
  "sale_pos_frontend.detailed_deliveryman.start.sale_date": "Fecha",
  "sale.sale.delivery.panel.modal.select_payment_required":
    "Selecciona un método de pago",
  "sale.sale.delivery.panel.modal.step1_subtitle":
    "Selecciona el método de pago",
  "sale.sale.delivery.panel.modal.step2_subtitle":
    "Revisa y confirma los montos a cobrar",
  "sale.sale.delivery.panel.modal.loading": "Cargando facturas...",
  "sale.sale.delivery.panel.modal.status_paid": "Pagado completo",
  "sale.sale.delivery.panel.modal.status_abono": "Abono $ {amount}",
  "sale.sale.delivery.panel.modal.status_error": "Error al procesar",
  "sale.sale.delivery.panel.modal.pending": "Queda pendiente $ {amount}",
  "sale.sale.delivery.panel.modal.error_title":
    "Algunos pagos tuvieron errores",
  "sale.sale.delivery.panel.modal.error_desc":
    "Las facturas con error no fueron procesadas. Revisa los detalles",
  "sale.sale.delivery.panel.modal.column.abonado": "Abonado",
  "sale.sale.delivery.panel.modal.column.por_cobrar": "Por cobrar",
  "sale.sale.delivery.panel.modal.column.payment_method": "Método",
  "sale.sale.delivery.panel.modal.column.a_pagar": "A pagar ahora",
  "sale.sale.delivery.panel.modal.column.factura": "Factura",
  "sale.sale.delivery.panel.modal.column.consumidor": "Consumidor",
  "sale.sale.delivery.panel.modal.column.total": "Total",
  "sale.sale.delivery.panel.modal.continue": "Continuar",
  "sale.sale.delivery.panel.modal.back": "Volver",
  "sale.sale.delivery.panel.modal.close": "Cerrar",
  "sale.sale.delivery.panel.modal.confirm_label": "Confirmar",
  "sale.sale.delivery.panel.modal.completed_title": "Facturado exitosamente",
  "sale.sale.delivery.panel.modal.partial_title":
    "Abono completado exitosamente",
  "sale.sale.delivery.panel.modal.processing_progress":
    "Procesando {progress} de {total} facturas...",
  "sale.sale.delivery.panel.modal.total_to_collect": "Total por cobrar",
  "sale.sale.delivery.panel.modal.to_collect_now": "A cobrar ahora",
  "sale.sale.delivery.panel.modal.max_amount": "Máx $ {amount}",
  "sale.sale.delivery.panel.modal.remaining": "Queda pendiente $ {amount}",
  "sale.sale.delivety.panel.modal.partial_paid":
    " Pago parcial (distribuir monto entre facturas)",
  "sale.sale.delivery.panel.modal.column.voucher": "Voucher",
  "sale.sale.delivery.panel.column.paid_amount": "Pagado",
  "sale.sale.delivery.panel.column.residual_amount": "Pendiente",
};

export default es;
